const options = {
  method: "GET",
  headers: { 'Content-Type': 'application/json' },
}

export function fetchAreas (callback) {
  fetch(process.env.REACT_APP_AREAS_URL, options)
    .then(response => response.json())
    .then(callback);
};

export function fetchArea(area,id, callback) {
  Promise.all([fetchAreaFeatures(area), fetchAreaData(id)])
    .then(callback)
};

function fetchAreaData(id) {
  return fetch(process.env.REACT_APP_AREA_URL+id, options)
    .then(response => response.json())
}

function fetchAreaFeatures(zone) {
  return fetch("zones/"+zone+"_zone.geo.json", options)
    .then(response => response.json())
}

export function fetchPlots(args) {
  const options = {
    method: "post",
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(args),
  }
  return fetch(process.env.REACT_APP_PLOT_URL, options)
};

export function fetchSearch(args, callback) {
  const options = {
    method: "post",
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(args),
  }
  fetch(process.env.REACT_APP_SEARCH_URL, options)
    .then(response => response.json())
    .then(callback)
};